import React, { forwardRef } from 'react'

import InlineLink from 'components/Typography/links/InlineLink'

import BaseText from '../BaseText'
import { ExportTextProps } from '../BaseText/types'

// method that returns whether or not the given child has a valid type
const hasValidType = (child): boolean => {
  if (typeof child === 'string') {
    return true
  }
  if (React.isValidElement(child) && (child.type === InlineLink || child.type === 'br')) {
    return true
  }
  return false
}

// method that throws errors at runtime in case there are invalid children
const throwInvalidContentError = (content): void => {
  let contentType: string = typeof content
  if (React.isValidElement(content)) {
    if (typeof content.type !== 'string') {
      contentType = content.type.name || typeof content.type
    } else {
      contentType = content.type
    }
  }

  throw new TypeError(`The following content is not allowed inside a BodyText: ${contentType}`)
}

const BodyText: React.FC<ExportTextProps> = forwardRef(({ Tag = 'p', children, ...props }) => (
  <BaseText Tag={Tag} size="default" {...props}>
    {React.Children.toArray(children).every((child) => {
      if (hasValidType(child)) {
        return true
      }
      throwInvalidContentError(child)
      return false
    }) && children}
  </BaseText>
))

export default BodyText
